import { render, staticRenderFns } from "./welfare-related.vue?vue&type=template&id=6e27b944&scoped=true&"
import script from "./welfare-related.vue?vue&type=script&lang=js&"
export * from "./welfare-related.vue?vue&type=script&lang=js&"
import style0 from "./welfare-related.vue?vue&type=style&index=0&id=6e27b944&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e27b944",
  null
  
)

export default component.exports